<app-header></app-header>

<div class="main-container d-flex">
  <app-sidebar></app-sidebar>

  <div class="container-fluid h-100p overflow-y-scroll notifications-main px-2 px-sm-3 px-lg-4">
    <div class="notifications-page">
      <header class="notifications-hero">
        <div class="notifications-hero-text">
          <h1 class="notifications-title">Notifications</h1>
          <p class="notifications-subtitle">
            Updates about credits, plans, and account activity.
          </p>
        </div>
        <button
          type="button"
          class="notifications-mark-all"
          [disabled]="markingAll || unreadCount <= 0"
          (click)="onMarkAllAsRead()"
        >
          Mark all as read
        </button>
      </header>

      <div class="notifications-filters" role="tablist" aria-label="Notification filters">
        <button
          type="button"
          class="notifications-filter"
          role="tab"
          [class.is-active]="filter === 'all'"
          [attr.aria-selected]="filter === 'all'"
          (click)="setFilter('all')"
        >
          All
        </button>
        <button
          type="button"
          class="notifications-filter"
          role="tab"
          [class.is-active]="filter === 'unread'"
          [attr.aria-selected]="filter === 'unread'"
          (click)="setFilter('unread')"
        >
          Unread
          <span *ngIf="unreadCount > 0" class="notifications-filter-count">{{ unreadCount }}</span>
        </button>
      </div>

      <section class="notifications-feed" aria-live="polite">
        <div *ngIf="isLoading" class="notifications-state">Loading…</div>

        <div *ngIf="!isLoading && loadError" class="notifications-state is-error">
          {{ loadError }}
          <button type="button" class="notifications-retry" (click)="reload()">Retry</button>
        </div>

        <div
          *ngIf="!isLoading && !loadError && notifications.length === 0"
          class="notifications-state"
        >
          No notifications
        </div>

        <ul
          *ngIf="!isLoading && !loadError && notifications.length > 0"
          class="notifications-list"
        >
          <li
            *ngFor="let item of notifications; trackBy: trackById"
            class="notifications-item"
            [attr.id]="'notification-' + item.notification_id"
            [class.is-unread]="!item.is_read"
            [class.is-expanded]="isExpanded(item)"
            [class.is-focused]="isFocused(item)"
          >
            <button
              type="button"
              class="notifications-item-main"
              [attr.aria-expanded]="isExpanded(item)"
              (click)="onRowClick(item)"
            >
              <span *ngIf="!item.is_read" class="notifications-unread-dot" aria-hidden="true"></span>
              <span class="notifications-item-content">
                <span class="notifications-item-title">{{ item.title }}</span>
                <span
                  *ngIf="displayBody(item)"
                  class="notifications-item-body"
                  [class.is-expanded]="isExpanded(item)"
                >{{ displayBody(item) }}</span>
              </span>
              <time class="notifications-item-time">{{ relativeTime(item.created_on) }}</time>
            </button>
            <button
              type="button"
              class="notifications-item-delete"
              [attr.aria-label]="'Delete ' + item.title"
              title="Delete"
              [disabled]="deletingId === item.notification_id"
              (click)="onDeleteOne(item, $event)"
            >
              <i class="bi bi-x" aria-hidden="true"></i>
            </button>
          </li>
        </ul>

        <div *ngIf="!isLoading && hasMore" class="notifications-more-wrap">
          <button
            type="button"
            class="notifications-more"
            [disabled]="isLoadingMore"
            (click)="loadMore()"
          >
            {{ isLoadingMore ? 'Loading…' : 'Show more' }}
          </button>
        </div>
      </section>
    </div>
  </div>
</div>
